import classNames from "classnames";

export const Title1 = ({ children, className = "", ...rest }) => {
  return (
    <div
      className={classNames("font-bold text-[24px] mb-[28px]", className)}
      {...rest}
    >
      {children}
    </div>
  );
};

export const Title2 = ({ children, className = "", ...rest }) => {
  return (
    <div
      className={classNames("font-black text-[14px] mb-[28px]", className)}
      {...rest}
    >
      {children}
    </div>
  );
};

export const Section = ({ children, className = "", ...rest }) => {
  return (
    <div
      className={classNames(
        "font-light text-[14px] leading-[22px] mb-[28px]",
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export const Col1 = ({ children, className = "", ...rest }) => {
  return (
    <div className={classNames("flex-1", className)} {...rest}>
      {children}
    </div>
  );
};

export const Col2 = ({
  title = undefined,
  children = null,
  className = "",
  ...rest
}) => {
  return (
    <div
      className={classNames("w-[380px] ml-[44px] mb-[28px]", className)}
      {...rest}
    >
      {children && (
        <>
          <div className="bg-hero h-[4px]"></div>
          <div className="relative">
            <div className="absolute w-[24px] min-w-[24px]">
              <div className="w-0 h-0 border-[12px] border-solid border-transparent border-t-[#18191C] border-r-[#18191C]"></div>
            </div>
            <div
              className="relative inline-block left-[22px] right-[22px] bg-[#18191C] p-[24px]"
              style={{ width: "calc(100% - 22px)" }}
            >
              {title && (
                <div className="text-[24px] font-bold mb-[24px]">{title}</div>
              )}
              <div className="font-light text-[14px] leading-[22px]">
                {children}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
